var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-card',{attrs:{"customClasses":"mb-6 mt-6","colClasses":"xl12 lg12 md12 xs12 sm12","removePanel":true,"viewMore":true,"disableNotification":true,"settings":true}},[_c('buy-or-sell')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }